import React, { useState } from "react";
import { Localized } from "fluent-react/compat";

import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Card from "@material-ui/core/Card";

import CallApi from "../../../utils/CallApi";
import SnackBar from "../../../components/user/SnackBar";
import checkRed from "../../../img/svg/check-red.svg";
import defaultImageList from "./images";
import ImageUploader from "./components/ImageUploader";

const Presentation = ({ onUpdateImages, selectedImages, restaurantId, token }) => {
  const [isSnackOpen, showSnack] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (image) => {
    const hasCustomImage = selectedImages.length && selectedImages[0].image.name === "tr-image-custom-name";

    if (hasCustomImage && image.name !== "tr-image-custom-name") {
      if (!window.confirm("Votre photo personnalisée sera remplacée. Souhaitez-vous poursuivre ?")) {
        return;
      }
    }

    try {
      const url = "restaurant/admin/info";
      const payload = { update: "imgToDisplay", images: [{ image }] };
      const result = await CallApi("PUT", url, restaurantId, payload, token);

      if (result && result[0].success) {
        setSuccess(true);
        onUpdateImages(payload);
      } else {
        setSuccess(false);
      }
    } catch (e) {
      setSuccess(false);
    }
    showSnack(true);
  };

  const selectedImageName = selectedImages.length ? selectedImages[0]?.image?.name : "";

  return (
      <div className="container container-presentation">
          <h2><Localized id="tr-admin-card-upload-label"/></h2>
          <p className="tr-admin-card-rgpd"><Localized id="tr-admin-card-rgpd"/></p>
          <p className="file-uploader-rules"><Localized id="tr-file-uploader-rules"/></p>
          <ImageUploader
              restaurantId={restaurantId}
              token={token}
              onImageUpdate={handleSubmit}
          />
          <h2>
              <Localized id="tr-link-title-presentation"/>
          </h2>
          <div className="container-list-images">
              {defaultImageList.map((img, index) => (
                  <Card
                      key={index}
                      className={`card-container ${
                          selectedImageName === img.name ? "card-container--selected" : ""
                      }`}
                      onClick={() => handleSubmit(img)}
                  >
                      <CardActionArea>
                          <CardMedia className="card-media" image={img.value}/>
                          {selectedImageName === img.name && (
                              <span className="image-checked">
                  <img src={checkRed} alt=""/>
                </span>
                          )}
                          <CardContent className="card-content">
                              <p className="text-image">
                                  <Localized id={img.name}/>
                              </p>
                          </CardContent>
                      </CardActionArea>
                  </Card>
              ))}
          </div>
          <SnackBar
              handleCloseSnack={() => showSnack(false)}
              success={success}
              open={isSnackOpen}
              text={<Localized id={`tr-admin-change-${success ? "save" : "error"}`}/>}
          />
      </div>
  );
};

export default Presentation;
